<template>
    <div class="panel">
        <div class="flex justify-between items-center">
            <span class="xs:text-lg md:text-2xl">{{ title }}</span>
            <a-icon type="close" 
                class="cursor-pointer mx-2"
                v-close-popover></a-icon>
        </div>
        <vs-divider/>
        <div class="flex justify-between my-4" v-if="!hideEnable">
            <slot name="label">Habilitar</slot>
            <vs-switch v-model="enabled" />
        </div>
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            value: Boolean,
            hideEnable: Boolean,
        },
        computed: {
            enabled: {
                get () { return this.value; },
                set (v) { 
                    this.$emit('input', v);
                    if (!v)
                        this.$emit('closePanel');
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .panel {
        min-width: 250px;
    }
</style>